import { api } from '../../../../api';
import { restaurantCalls } from '../../../../config/api';

// @todo Избавиться от дублей запросов: есть аналогичный запрос (getSectionTablesReq) для работы с сагами
export const getSectionsRequest = (restaurantId: number) =>
  api
    .get(`${restaurantCalls}/${restaurantId}/section`)
    .then((r: GM.ReservesSchemas.Response.Sections) => r);
